module.exports = __webpack_public_path__ + "img/pro_acountants.a039017f.svg";